import * as React from 'react';
import { withRouter } from 'react-router';
import { Tooltip } from 'antd';
import AccessPermissionChecker from '../common/AccessPermissionChecker';

const style = require('./SubnavTabs.less');

const DISABLED_TAB_TOOLTIP = 'Coming soon';

// A tab is `disabled` when the surface it points at isn't available yet — it stays visible for
// discoverability but doesn't navigate.
const SubnavTab = ({ tab, isActive, onChange }) => {
	const handleClick = () => onChange(tab.key);

	if (tab.disabled) {
		return (
			<Tooltip title={DISABLED_TAB_TOOLTIP}>
				<li className="disabled">{tab.name}</li>
			</Tooltip>
		);
	}

	return (
		<li onClick={handleClick} className={isActive(tab.key) ? 'active' : ''}>
			{tab.name}
		</li>
	);
};

class SubnavTabs extends React.Component<any, any> {
	render() {
		const {
			onChange,
			tabs,
			isActive,
			tabsRightActions,
			className = 'justify-between',
		} = this.props;
		return (
			<div className={`tab-block flex flex-row  ${className}`} id="tab-block">
				<ul className="tab-mnu">
					{tabs.map((tab) => (
						<AccessPermissionChecker key={tab.key} name={tab.accessPermissionName}>
							<SubnavTab tab={tab} isActive={isActive} onChange={onChange} />
						</AccessPermissionChecker>
					))}
				</ul>
				{(tabsRightActions && tabsRightActions()) || null}
			</div>
		);
	}
}

export default withRouter(SubnavTabs);
